
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3.5a8.956 8.956 0 018.085 5.041 8.841 8.841 0 01-2.21 2.86l1.293 1.293a10.819 10.819 0 002.915-4.153C19.497 4.517 15.583 1.666 11 1.666c-1.164 0-2.283.184-3.337.523L9.176 3.7C9.77 3.582 10.376 3.5 11 3.5zm-.981 1.045l1.897 1.897c.523.23.945.651 1.174 1.174l1.897 1.897c.074-.312.129-.642.129-.98.009-2.274-1.843-4.117-4.116-4.117-.34 0-.66.046-.981.129zM1.842 1.547L4.3 4.004A10.76 10.76 0 00.917 8.54c1.585 4.025 5.5 6.875 10.083 6.875 1.393 0 2.732-.265 3.96-.751l3.135 3.135 1.292-1.293L3.135.246 1.842 1.547zm6.875 6.875l2.393 2.393c-.037.009-.073.018-.11.018a2.292 2.292 0 01-2.292-2.292c0-.045.01-.073.01-.119zM5.601 5.306L7.205 6.91a4.217 4.217 0 00-.33 1.631 4.131 4.131 0 005.747 3.795l.899.899c-.807.22-1.65.348-2.521.348a8.956 8.956 0 01-8.085-5.042A9.077 9.077 0 015.6 5.306z","fill":"#BFBFBF"}})])
          )
        }
      }
    